import React, { Component } from 'react';

export default class ResultStatusRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasResults: false,
            resultStatus: '',
            statusColor: '',
            abnormalCount: 0,
            inconsistentCount: 0,
            totalCount: 0
        };
    }

    componentDidMount() {
        this.updateResultStatus();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.updateResultStatus();
        }
    }

    updateResultStatus = () => {
        const { data } = this.props;

        if (!data || !data.results) {
            this.setState({
                hasResults: false,
                resultStatus: 'Pending',
                statusColor: '#666'
            });
            return;
        }

        // Check if order is cancelled
        if (data.is_cancel) {
            this.setState({
                hasResults: false,
                resultStatus: 'Cancelled',
                statusColor: '#dc3545'
            });
            return;
        }

        // Check for qualitative test (single result value)
        if (data.results.value) {
            const value = data.results.value.toLowerCase();
            let statusColor = '#28a745'; // green by default

            if (value.includes('positive') || value.includes('detected')) {
                statusColor = '#dc3545'; // red for positive
            } else if (value.includes('invalid') || value.includes('inconclusive')) {
                statusColor = '#ffc107'; // yellow for invalid/inconclusive
            }

            this.setState({
                hasResults: true,
                resultStatus: data.results.value,
                statusColor: statusColor
            });
            return;
        }

        // Check for quantitative test (multiple analyte values)
        if (data.results.values && data.results.values.length > 0) {
            const totalCount = data.results.values.length;
            
            // Count flags and outcomes
            const inconsistentCount = data.results.values.filter(v => v.flagOutcome === 'Inconsistent').length;
            const abnormalCount = data.results.values.filter(
                (v) => v.analyteFlag && (v.analyteFlag === 'H' || v.analyteFlag === 'L' || v.analyteFlag === 'A')
            ).length;

            let statusText = `${totalCount} analyte${totalCount > 1 ? 's' : ''} complete`;
            let statusColor = '#28a745'; // green

            // Prioritize inconsistent results
            if (inconsistentCount > 0) {
                statusText = `${totalCount} analytes - ${inconsistentCount} inconsistent`;
                statusColor = '#dc3545'; // red for inconsistent
            } else if (abnormalCount > 0) {
                statusText = `${totalCount} analytes - ${abnormalCount} abnormal`;
                statusColor = '#ffc107'; // yellow for abnormal
            }

            this.setState({
                hasResults: true,
                resultStatus: statusText,
                statusColor: statusColor,
                abnormalCount: abnormalCount,
                inconsistentCount: inconsistentCount,
                totalCount: totalCount
            });
            return;
        }

        // No results yet
        this.setState({
            hasResults: false,
            resultStatus: 'Pending',
            statusColor: '#666'
        });
    };

    handleClick = () => {
        // For quantitative tests, trigger the analyte popup
        if (this.props.data.results && this.props.data.results.values && this.props.data.results.values.length > 0) {
            // Find and click the analyte result cell
            const row = this.props.node;
            const analyteCell = row.gridOptionsWrapper.gridOptions.api.getCellRendererInstances({
                rowNodes: [row],
                columns: ['results.values']
            })[0];

            if (analyteCell && analyteCell.setState) {
                analyteCell.setState({ showPopup: true });
            }
        }
    };

    render() {
        const { hasResults, resultStatus, statusColor, abnormalCount, inconsistentCount } = this.state;
        const isQuantitative = this.props.data?.results?.values?.length > 0;
        const hasAbnormal = abnormalCount > 0;
        const hasInconsistent = inconsistentCount > 0;

        return (
            <div
                style={{
                    color: statusColor,
                    fontWeight: hasResults ? '500' : 'normal',
                    cursor: isQuantitative ? 'pointer' : 'default'
                }}
                onClick={isQuantitative ? this.handleClick : undefined}
                title={isQuantitative ? 'Click to view all analytes' : ''}
            >
                {(hasInconsistent || hasAbnormal) && <span style={{ marginRight: '5px' }}>⚠️</span>}
                {resultStatus}
                {isQuantitative && (
                    <span style={{ marginLeft: '5px', fontSize: '0.8em', opacity: 0.7 }}>
                        <i className="fa fa-external-link"></i>
                    </span>
                )}
            </div>
        );
    }
}
